var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDishes = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 40 40"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  stroke: "#58595B"
}, /*#__PURE__*/React.createElement("path", {
  d: "m23.745 31.936-5.9-13.3c.2-2-.6-5-1.3-6.9-1.2-2.9-4-4.5-4.9-4.2 0 0 1.2 3.3 2.4 6.2s2.9 6.8 2.9 6.8l4.401 12.1c.1.3.8.4 1.5.2.6-.2 1-.6.9-.9Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m18.146 24.236-3.2 7.6c-.1.299.3.799 1 1s1.4.1 1.5-.201l1.8-5.299M19.245 21.736l1.9-4.5c-1.9-.8-1.9-2.3-1-4.9v-.1l6.4 1.9c0 .1 0 .1-.1.2-1 2.5-2 3.6-3.9 3.4l-2.2 6.6M20.146 12.236l1.8-4.7M22.245 12.736l1.8-4.7M24.346 13.436l1.8-4.6M26.545 14.136l1.801-4.7"
}))));
export default SvgDishes;